// extracted by mini-css-extract-plugin
module.exports = {"toolTipContainer":"AutofillTooltip_toolTipContainer__lgB8Q","toolTipText":"AutofillTooltip_toolTipText__ldZGW"};